/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../../core/error/error-name';

/**
 * Správce obrazovky pro standardní webové technologie.
 * @implements {ScreenManager}
 * @memberof AdapterWeb
 */
class ScreenManager {
  /**
   * Vytvoří instanci.
   * @param {OrientationEnum} orientationEnum Výchozí orientace obrazovky.
   * @returns {ScreenManager} Nová instance.
   */
  constructor(orientationEnum) {
    this.orientationEnum = orientationEnum;
  }

  /** @inheritdoc */
  createScreenshot() {
    return new Promise(() => {
      const error = new Error('Unable to create the screenshot.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  getBrightness() {
    return new Promise(() => {
      const error = new Error('Unable to get the brightness.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  getCssOrientation() {
    return new Promise((resolve) => resolve(this.orientationEnum));
  }

  /** @inheritdoc */
  getOrientation() {
    return new Promise((resolve) => resolve(this.orientationEnum));
  }

  /** @inheritdoc */
  setOrientation(orientationEnum) {
    return new Promise((resolve) => {
      this.orientationEnum = orientationEnum;
      return resolve();
    });
  }
}

export default ScreenManager;
